import React from 'react';
import './KPICard.css';

/**
 * KPICard Component
 * Displays a key performance indicator with optional trend, sparkline, and status
 */
function KPICard({
    title,
    value,
    subtitle,
    trend,
    trendValue,
    status,
    icon,
    onClick,
    loading,
    className
}) {
    const getStatusClass = () => {
        if (!status) return '';
        switch (status) {
            case 'good':
            case 'success':
                return 'kpi-status-good';
            case 'warning':
                return 'kpi-status-warning';
            case 'danger':
            case 'critical':
                return 'kpi-status-danger';
            default:
                return '';
        }
    };

    const getTrendIcon = () => {
        if (!trend) return null;
        switch (trend) {
            case 'up':
                return (
                    <span className="kpi-trend kpi-trend-up">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                            <polyline points="17 6 23 6 23 12"></polyline>
                        </svg>
                        {trendValue && <span>{trendValue}%</span>}
                    </span>
                );
            case 'down':
                return (
                    <span className="kpi-trend kpi-trend-down">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>
                            <polyline points="17 18 23 18 23 12"></polyline>
                        </svg>
                        {trendValue && <span>{Math.abs(trendValue)}%</span>}
                    </span>
                );
            case 'flat':
                return (
                    <span className="kpi-trend kpi-trend-flat">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                    </span>
                );
            default:
                return null;
        }
    };

    return (
        <div
            className={`kpi-card ${getStatusClass()} ${onClick ? 'kpi-card-clickable' : ''} ${className || ''}`}
            onClick={onClick}
        >
            {loading ? (
                <div className="kpi-loading">
                    <div className="kpi-loading-spinner"></div>
                </div>
            ) : (
                <>
                    <div className="kpi-header">
                        <span className="kpi-title">{title}</span>
                        {icon && <span className="kpi-icon">{icon}</span>}
                    </div>
                    <div className="kpi-body">
                        <span className="kpi-value">{value}</span>
                        {getTrendIcon()}
                    </div>
                    {subtitle && <div className="kpi-subtitle">{subtitle}</div>}
                </>
            )}
        </div>
    );
}

export default KPICard;
